import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { IMAGES, SERVICES } from "@/data/site";
import { Reveal, SectionHead } from "./Reveal";

const Card = ({ s, i }) => {
  const Icon = Icons[s.icon] || Icons.Circle;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative border border-gold/15 bg-slateCard/40 p-8 lg:p-10 hover:border-gold/60 hover:-translate-y-1 hover:shadow-[0_18px_50px_rgba(212,175,55,0.12)] transition-[border-color,transform,box-shadow] duration-400 ${s.featured ? "md:col-span-2 md:row-span-2 flex flex-col justify-end min-h-[420px] overflow-hidden" : ""}`}
      data-testid={`service-card-${i}`}
    >
      {s.featured && (
        <>
          <img src={IMAGES.estate} alt="Brick estate property" className="absolute inset-0 h-full w-full object-cover opacity-50 group-hover:scale-105 transition-transform duration-[1.4s] ease-out" />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-transparent" />
        </>
      )}
      <div className="relative">
        <Icon size={22} strokeWidth={1.25} className="text-gold" />
        <h3 className="mt-6 font-serif text-2xl lg:text-3xl text-ivory">{s.title}</h3>
        <p className="mt-3 text-ivory/60 leading-relaxed text-sm lg:text-base">{s.body}</p>
        {s.link && (
          <Link to={s.link} className="mt-5 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-gold link-underline" data-testid={`service-link-${i}`}>
            Explore <ArrowRight size={12} />
          </Link>
        )}
      </div>
      <span className="absolute top-8 right-8 font-mono text-xs text-ivory/25">0{i + 1}</span>
    </motion.div>
  );
};

export const Services = () => (
  <section id="services" className="relative py-28 lg:py-40" data-testid="services-section">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <SectionHead index="03" eyebrow="What We Do" title={<>Every piece of the deal, handled.</>} className="lg:col-span-6" />
        <Reveal delay={0.2} className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
          <Link to="/private-lending" className="group inline-flex items-center gap-3 text-xs tracking-[0.2em] uppercase text-gold" data-testid="services-lending-btn">
            Learn about private lending
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
      <div className="grid md:grid-cols-3 gap-4 lg:gap-5">
        {SERVICES.map((s, i) => (
          <Card key={s.title} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
